import { compose } from 'redux';
import { connect } from 'react-redux';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import withReducer from '@Hooks/withReducer';
import InstitutionReducer from './InstitutionReducer';
import { institutionReducerKey } from './InstitutionConstants';
import InstitutionModal from './InstitutionModal';
import {
  closeInstitutionModal,
  login,
  goToLastSelected,
  init,
  selectGroup,
  selectInstitution,
  selectSearchedInstitution,
  changeRememberMe,
  resetState,
} from './InstitutionActions';
import { openLoginModal } from '../LoginActions';
import { openRegisterModal } from '../Register/RegisterActions';
import {
  isLoading as isLoadingSelector,
  actualData as actualDataSelector,
  institutionsForSearch as institutionsForSearchSelector,
  institutionsGroups as institutionsGroupsSelector,
  isAnonymousUser as isAnonymousUserSelector,
  ipAddress as ipAddressSelector,
  notifications as notificationsSelector,
} from './InstitutionSelectors';

const mapStateToProps = (state, ownProps) => ({
  isAnonymousUser: isAnonymousUserSelector(),
  ipAddress: ipAddressSelector(state),
  isLoading: isLoadingSelector(state),
  institutionsForSearch: institutionsForSearchSelector(state),
  institutionsGroups: institutionsGroupsSelector(state),
  actualData: actualDataSelector(state),
  notifications: notificationsSelector(state),
  ...ownProps,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  cancel: () => dispatch(closeInstitutionModal()),
  closeModal: () => dispatch(closeInstitutionModal()),
  goToLastSelected: (institution) => dispatch(goToLastSelected(institution)),
  init: () => dispatch(init()),
  selectGroup: (group) => dispatch(selectGroup(group)),
  selectInstitution: (institution) => dispatch(selectInstitution(institution)),
  selectSearchedInstitution: (institution) => dispatch(selectSearchedInstitution(institution)),
  login: () => dispatch(login()),
  changeRememberMe: (value) => dispatch(changeRememberMe(value)),
  resetState: () => dispatch(resetState()),
  onEmailSignIn: () => {
    dispatch(closeInstitutionModal());
    dispatch(openLoginModal());
  },
  onRegister: () => {
    dispatch(closeInstitutionModal());
    dispatch(openRegisterModal());
  },
  ...ownProps,
});

export default compose(
  withCombinedRouteParams,
  withReducer(institutionReducerKey, InstitutionReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(InstitutionModal);
